import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { VehicleService } from '../vehicle.service';
import { Vehicle } from '../vehicle';

@Component({
  selector: 'app-vehicle-details',
  templateUrl: './vehicle-details.component.html',
  styles: []
})
export class VehicleDetailsComponent implements OnInit, OnDestroy {
  classification: string[] = ['mother ship', 'terrastial vehicle', 'fighter vehicle'];
  vehicle: Vehicle;
  sub: any;

  constructor(private route: ActivatedRoute,
              private vehicleService: VehicleService,
              private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      let id = params['id'];
      console.log('getting vehicle with id:  ', id);
      this.vehicleService
        .get(id)
        .subscribe(v => this.vehicle = v);
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  gotoVehiclesList(){
    let link = ['/vehicles'];
    this.router.navigate(link);
  }

  /* 
  //alternatively use:
  gotoPeoplesList(){
      window.history.back();
  }
  */
}



// WEBPACK FOOTER //
// ./src/app/vehicle-details/vehicle-details.component.ts